<template>
  <div class="dashboard container py-4">
    <h2 class="text-center mb-4 display-4">Dashboard</h2>

    <!-- Stats Overview -->
    <div class="row g-4 mb-4">
      <div class="col-md-6 col-lg-3">
        <div class="stat-card shadow-sm p-4 d-flex flex-column align-items-center justify-content-center" style="background: linear-gradient(135deg, #4e73df, #224abe);">
          <h5 class="text-white text-center">Monthly Total Page Visits</h5>
          <p class="stat-value text-white">{{ stats.monthlyTotalPageVisits }}</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-3">
        <div class="stat-card shadow-sm p-4 d-flex flex-column align-items-center justify-content-center" style="background: linear-gradient(135deg, #1cc88a, #138c65);">
          <h5 class="text-white text-center">Monthly Unique Visitors</h5>
          <p class="stat-value text-white">{{ stats.monthlyUniqueVisitors }}</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-3">
        <div class="stat-card shadow-sm p-4 d-flex flex-column align-items-center justify-content-center" style="background: linear-gradient(135deg, #36b9cc, #2a93a5);">
          <h5 class="text-white text-center">Daily Total Page Visits</h5>
          <p class="stat-value text-white">{{ stats.dailyTotalPageVisits }}</p>
        </div>
      </div>
      <div class="col-md-6 col-lg-3">
        <div class="stat-card shadow-sm p-4 d-flex flex-column align-items-center justify-content-center" style="background: linear-gradient(135deg, #f6c23e, #d3a027);">
          <h5 class="text-white text-center">Daily Unique Visitors</h5>
          <p class="stat-value text-white">{{ stats.dailyUniqueVisitors }}</p>
        </div>
      </div>
    </div>

    <!-- Visitor by Country & Page Daily Chart in a Single Row -->
    <div class="row g-4">
      <div class="col-md-6">
        <div class="chart-card shadow-sm p-4">
          <h5 class="text-center">Visitors by Country</h5>
          <canvas id="countryChart" class="chart-canvas"></canvas>
        </div>
      </div>
      <div class="col-md-6">
        <div class="chart-card shadow-sm p-4">
          <h5 class="text-center">Visitor Count by Page (Daily)</h5>
          <canvas id="pageVisitsChart" class="chart-canvas"></canvas>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import Chart from "chart.js/auto";

export default {
  name: "DashboardView",
  setup() {
    const stats = ref({
      monthlyTotalPageVisits: 12500,
      monthlyUniqueVisitors: 4500,
      dailyTotalPageVisits: 400,
      dailyUniqueVisitors: 150,
    });

    const countryChartData = {
      labels: ["USA", "Canada", "UK", "Germany", "France"],
      datasets: [
        {
          label: "Visitors by Country",
          data: [400, 300, 250, 200, 150],
          backgroundColor: ["#4e73df", "#1cc88a", "#36b9cc", "#f6c23e", "#e74a3b"],
        },
      ],
    };

    const pageVisitsChartData = {
      labels: ["Home", "About", "Contact", "Blog", "Shop"],
      datasets: [
        {
          label: "Visitor Count by Page",
          data: [120, 90, 60, 110, 80],
          backgroundColor: "#36b9cc",
        },
      ],
    };

    onMounted(() => {
      new Chart(document.getElementById("countryChart").getContext("2d"), {
        type: "pie",
        data: countryChartData,
      });

      new Chart(document.getElementById("pageVisitsChart").getContext("2d"), {
        type: "bar",
        data: pageVisitsChartData,
        options: {
          responsive: true,
          scales: {
            x: { beginAtZero: true },
            y: { beginAtZero: true },
          },
        },
      });
    });

    return {
      stats,
    };
  },
};
</script>

<style scoped>
.container {
  max-width: 1200px;
}
.display-4 {
  font-weight: bold;
  color: #343a40;
}
.stat-card {
  border-radius: 8px;
  transition: transform 0.2s ease;
  height: 180px; /* Fixed height for uniform card size */
}
.stat-card:hover {
  transform: scale(1.05);
}
.stat-value {
  font-size: 2em;
  font-weight: bold;
  margin-top: 10px;
}
.chart-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  height: 300px; /* Fixed height for chart containers */
}
.chart-canvas {
  max-height: 250px; /* Max height for charts */
}
h5 {
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
}
</style>
